import { profitTypes } from 'live/components/index.shared';
import TopProfit from 'live/components/TopProfit';
import { liveLoadProfits, liveLoadTopProfitMonth } from 'live/redux/actions';
import { topList, ui } from 'live/redux/selectors';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

const mapStateToProps = (state, ownProps) => {
  const { month, year } = ownProps;
  const data = {};

  profitTypes.map(
    type =>
      (data[type] = {
        error: topList.getTopListError(state, { type, month, year }),
        list: topList.getTopList(state, { type, month, year }),
        loading: topList.getTopListLoading(state, { type, month, year }),
      }),
  );

  return {
    data,
    section: ui.getSection(state),
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      loadProfits: liveLoadProfits,
      loadDididends: liveLoadTopProfitMonth,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(TopProfit);
